import EmploymentRoleEdit from "../Edits/EmploymentRoleEdit";
import CmModal from "../Controls/CmModal";

export default function EmploymentEditModal({ employmentId = 0, onClose }) {
  const id = Number.parseInt(employmentId, 10) || 0;
  const title = "Employment";

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="form"
      testId="employment-edit-modal"
    >
      <EmploymentRoleEdit employmentId={id} onClose={onClose} />
    </CmModal>
  );
}
